import React from 'react';

import { Button as MuiButton, ButtonProps } from '@mui/material';

import useStyles from './styles';

const Button: React.FC<ButtonProps> = ({ classes, ...restProps }) => {
    const { classes: internalClasses, cx } = useStyles();
    return (
        <MuiButton
            classes={{
                ...classes,
                root: cx(internalClasses.root, classes?.root),
                contained: cx(internalClasses.contained, classes?.contained),
                outlined: cx(internalClasses.outlined, classes?.outlined),
                disabled: cx(internalClasses.disabled, classes?.disabled)
            }}
            {...restProps}
        />
    );
};

export default React.memo(Button);
